import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sponsor-detail',
  templateUrl: './sponsor-detail.component.html',
  styleUrls: ['./sponsor-detail.component.sass']
})
export class SponsorDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
